// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1cXL3","total":"Cart_total__ueMcl","actions":"Cart_actions__gu-9c","button--alt":"Cart_button--alt__2Zbdi","button":"Cart_button__2ir9B"};